import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeadersForOrganisation } from "./apiHelpers";

const endpoint = spellbook("/attendances/{id}/dispute").POST();

export type SendDisputeReq = typeof endpoint.types.Req;

export type SendDisputeReqCore = Pick<
    SendDisputeReq,
    "companyId" | "managerId" | "shiftId" | "siderId" | "taskId" | "startDate" | "endDate"
>;

export async function sendDispute({
    params,
    req,
}: {
    params: typeof endpoint.types.P;
    req: SendDisputeReq;
}) {
    const call = createCall(endpoint, (r) =>
        fetch(withAccountOrNetworkAuthHeadersForOrganisation(r, req.companyId)),
    );
    return await call({ params, req });
}
